import type { QueryFunctionContext } from '@tanstack/react-query';
import { WorkspacesService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { workspacesKeys } from './workspacesKeys';

type TParams = QueryFunctionContext<ReturnType<typeof workspacesKeys.teamsBySlugs>>;

export const createFetchWorkspaceTeamsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ orgSlug, wsSlug }], signal }: TParams) =>
    call(() => cancelOnSignal(WorkspacesService.getTeams({ orgSlug, wsSlug }), signal));
